import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "./../../axios/axios";
import { UPLOAD_CATEGORY } from "../../lib/utils";

export const qualityInspection = createAsyncThunk(
  "user/qualityInspection",
  async (formData, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      const { data } = await instance.post(
        "/inspection/portal/qualityinspection",
        formData,
        config
      );

      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const userClockIn = createAsyncThunk(
  "user/ClockIn",
  async ({ userClockInOutData, token }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/user/portal/clock-in",
        userClockInOutData,
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const userClockCheckIns = createAsyncThunk(
  "user/get-check-ins",
  async ({ token }, { rejectWithValue }) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.get(
        "/user/portal/get-all-checkIns",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getActiveReps = createAsyncThunk(
  "user/active-reps",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.get(
        "/user/portal/get-active-reps",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getActiveRecruitees = createAsyncThunk(
  "user/active-recruitees",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.get(
        "/user/portal/get-active-recruitees",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getTrainingPercentage = createAsyncThunk(
  "user/training-percentage",
  async (requestData, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/stats/portal/get-training-percentage",
        requestData,
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const updateActiveReps = createAsyncThunk(
  "user/update-active-reps",
  async ({ updateActiveRepsData, recID }, { rejectWithValue }) => {
    try {
      const { data } = await instance.post(
        `/user/portal/active-reps/${recID}`,
        updateActiveRepsData
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const forgotPassword = createAsyncThunk(
  "user/forgot-password",
  async ({ forgotPasswordData }, { rejectWithValue }) => {
    try {
      const { data } = await instance.post(
        "/user/portal/forgot-password",
        forgotPasswordData
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const forgotUsername = createAsyncThunk(
  "user/forgot-username",
  async ({ forgotUsernameData }, { rejectWithValue }) => {
    try {
      const { data } = await instance.post(
        "/user/portal/forgot-username",
        forgotUsernameData
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);
export const getLedgerHistory = createAsyncThunk(
  "user/ledger-history",
  async (arg, { rejectWithValue }) => {
    try {
      // Back-compat: every existing caller passes the bare token and gets the
      // first page with no params — byte-identical to the old request. The
      // Balance page passes { token, limit, offset } to walk further back
      // through an account's history. (9/23/26)
      const token = typeof arg === "string" ? arg : arg?.token;
      const params =
        arg && typeof arg === "object"
          ? { limit: arg.limit, offset: arg.offset }
          : undefined;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.get(
        "/user/portal/get-ledger-history",
        { ...config, params }
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const fetchRecipients = createAsyncThunk(
  "user/fetch-recipients",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.get(
        "/balance/portal/recipients",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const sendPoints = createAsyncThunk(
  "user/send-points",
  async ({ recipientRecId, amount, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/balance/portal/send",
        { recipientRecId, amount, note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const requestPoints = createAsyncThunk(
  "user/request-points",
  async ({ fromRecId, amount, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/balance/portal/request",
        { fromRecId, amount, note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const challengePoints = createAsyncThunk(
  "user/challenge-points",
  async ({ opponentRecId, amount, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/balance/portal/challenge",
        { opponentRecId, amount, note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) {
        return rejectWithValue(error.response.data.message);
      } else {
        return rejectWithValue(error.message);
      }
    }
  }
);

export const getOpenChallenges = createAsyncThunk(
  "user/get-open-challenges",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/challenges", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const payChallenge = createAsyncThunk(
  "user/pay-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/pay`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const cancelChallenge = createAsyncThunk(
  "user/cancel-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/cancel`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const nudgeChallenge = createAsyncThunk(
  "user/nudge-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/nudge`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const acceptChallenge = createAsyncThunk(
  "user/accept-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/accept`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Caller claims victory on an accepted challenge. Server-side this is a
// one-shot per-side action — sends a magic-link "pay up" SMS to the other
// side and locks the Won button on the caller's side. No points move; the
// loser still has to hit Lost (or pay via payChallenge) to settle.
export const wonChallenge = createAsyncThunk(
  "user/won-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/won`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// "Lost" is the user-facing name for the existing payChallenge endpoint —
// caller declares THEY lost and the BFF transfers the stake to the other
// side. Aliased here so the Balance page can read as `handleLost(...)` even
// though the wire endpoint is still /pay (mounted in routes/balanceRoute.js).
export const lostChallenge = createAsyncThunk(
  "user/lost-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/challenges/${challengeId}/pay`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Multi-send challenge — one challenger opens an INDEPENDENT challenge against
// MANY opponents at once. Create writes one standalone challenge row per matched
// person (no group linkage); each is settled one-by-one like a 1:1 challenge.
// Mirrors the 1:1 challenge thunk but talks to the /challenge/group route.
export const challengeGroup = createAsyncThunk(
  "user/challenge-group",
  async ({ recipientRecIds, amount, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(
        "/balance/portal/challenge/group",
        { recipientRecIds, amount, note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Pinned Request rows — mirror of the Challenge thunks above. List, then
// per-row Pay (From-side), Cancel (either side), Nudge (1 per 24h per side).
export const getOpenRequests = createAsyncThunk(
  "user/get-open-requests",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/requests", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

const requestPostThunk = (typePrefix, suffix) =>
  createAsyncThunk(typePrefix, async ({ requestId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(`/balance/portal/requests/${requestId}/${suffix}`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  });

export const payRequest = requestPostThunk("user/pay-request", "pay");
export const cancelRequest = requestPostThunk("user/cancel-request", "cancel");
export const nudgeRequest = requestPostThunk("user/nudge-request", "nudge");

// Points-to-Pay (Phase 2 portal-ui side; Phase 1 BFF endpoints merged in
// Portal-BFF PR #758 — see tech_map/systems/portal/points-to-pay-design.md).
// All four endpoints are gated to the caller's own employee record server-side.
export const getPointsToPayEligibility = createAsyncThunk(
  "user/points-to-pay/eligibility",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get(
        "/balance/portal/points-to-pay/eligibility",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const getPointsToPayPending = createAsyncThunk(
  "user/points-to-pay/pending",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get(
        "/balance/portal/points-to-pay/pending",
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const convertPointsToPay = createAsyncThunk(
  "user/points-to-pay/convert",
  async ({ points }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      };
      const { data } = await instance.post(
        "/balance/portal/points-to-pay/convert",
        { points },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const cancelPointsToPay = createAsyncThunk(
  "user/points-to-pay/cancel",
  async ({ ledgerId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        `/balance/portal/points-to-pay/cancel/${ledgerId}`,
        {},
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// My Points page — read-only leaderboard rank (top employees + caller's rank).
export const getPointsLeaderboard = createAsyncThunk(
  "user/points-leaderboard",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/leaderboard", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Balance page — read-only Challenge + Bet leaderboards (top earners by
// challenge winnings and by bet winnings, plus the caller's rank in each).
// Mirrors getPointsLeaderboard: token from auth state, returns { status, message, data }.
export const getChallengeBetLeaderboard = createAsyncThunk(
  "user/challenge-bet-leaderboard",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/challenge-leaderboard", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// My Points page — read-only "Ways to Earn" (point-earning actions from ledger).
export const getWaysToEarn = createAsyncThunk(
  "user/ways-to-earn",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/ways-to-earn", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Feature #11 (Notifications page) — the calling user's received push
// notifications, newest first. Mirrors getPointsLeaderboard: token from
// auth state, GET to the Phase-1 BFF endpoint, returns { status, message, data }.
export const getReceivedNotifications = createAsyncThunk(
  "user/received-notifications",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/notification/portal/received", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Upload attachment files (images, videos, PDFs, audio) for a notification.
// Accepts a FileList or File[] and posts multipart to POST /notification/portal/upload-media.
// Returns [{url, name, mimeType, category}] for inclusion in the sendNotification payload.
export const uploadNotificationMedia = createAsyncThunk(
  "user/upload-notification-media",
  async (files, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const form = new FormData();
      for (const f of files) form.append("files", f);
      const { data } = await instance.post(
        "/notification/portal/upload-media",
        form,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Admin send: push a web notification to a filtered cohort. Mirrors the BFF
// contract (POST /notification/portal/send): positions/locations are arrays of
// label strings, employeeRecIds is an array of Employees-base record ids that
// overrides the position/location filters. The BFF requires at least one filter.
// mediaUrls is an optional array of {url,name,mimeType,category} from uploadNotificationMedia.
export const sendNotification = createAsyncThunk(
  "user/send-notification",
  async ({ title, body, url, positions, locations, employeeRecIds, scheduledFor, mediaUrls }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        "/notification/portal/send",
        { title, body, url, positions, locations, employeeRecIds, scheduledFor, mediaUrls },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// List pending scheduled notifications (admin "Scheduled" panel on the Send
// Notifications composer). Mirrors GET /notification/portal/scheduled.
export const listScheduledNotifications = createAsyncThunk(
  "user/list-scheduled-notifications",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/notification/portal/scheduled", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Cancel a still-pending scheduled notification. Mirrors POST
// /notification/portal/scheduled/cancel { id }.
export const cancelScheduledNotification = createAsyncThunk(
  "user/cancel-scheduled-notification",
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/scheduled/cancel", { id }, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// List previously-sent notifications (admin "Sent" history panel on the Send
// Notifications composer). Mirrors GET /notification/portal/sent — one entry per
// send with recipient count, recipient names, and the time it went out.
export const listSentNotifications = createAsyncThunk(
  "user/list-sent-notifications",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/notification/portal/sent", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Feature #11 — dismiss one received notification (the in-portal banner X).
// Server-side so it clears on every device the user is on; the row stays on the
// Notifications page (history). Mirrors the BFF contract POST
// /notification/portal/dismiss { id }.
export const dismissNotification = createAsyncThunk(
  "user/dismiss-notification",
  async ({ id }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/dismiss", { id }, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Click a Yes/No action button on a notification (the Glitch verify flow).
// The BFF records the answer on the notification + glitch, pays the submitter
// 25 pts from Levi's wallet (once per glitch), and notifies the President.
// Mirrors POST /notification/portal/respond { id, value }. Returns
// { response, pointsPaid, payoutPending, glitch }.
export const respondToNotification = createAsyncThunk(
  "user/respond-notification",
  async ({ id, value }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/respond", { id, value }, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Notification Control Hub (Phase 2) — read the calling user's grouped
// notification preferences (every category with current in-portal / phone-push
// toggle state, defaults on). Mirrors GET /notification/portal/preferences;
// returns { status, message, data: groups[] }.
export const getNotificationPreferences = createAsyncThunk(
  "user/get-notification-preferences",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/notification/portal/preferences", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Save notification toggles. Accepts a single { category_key, in_portal, push }
// or a bulk { prefs: [ ... ] }. The BFF silently ignores unknown / non-mutable
// categories and returns the fresh effective prefs in `data`, so the hub
// re-renders from server truth. Mirrors POST /notification/portal/preferences.
export const saveNotificationPreferences = createAsyncThunk(
  "user/save-notification-preferences",
  async (body, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/preferences", body, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Notification Control Hub (Phase 3B) — the calling user's delivery settings:
// Quiet Hours (quiet_enabled + quiet_start/quiet_end as minutes-of-day, anchored
// to Central HQ time) and the 24h mute (muted_until ISO). Mirrors GET
// /notification/portal/user-settings; returns { status, message, data }.
export const getNotificationUserSettings = createAsyncThunk(
  "user/get-notification-user-settings",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/notification/portal/user-settings", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Save delivery settings. Accepts any subset of
// { quiet_enabled, quiet_start, quiet_end, muted_until } plus a convenience
// { mute_hours } (mutes for N hours from now). The BFF returns the fresh
// settings in `data`. Mirrors POST /notification/portal/user-settings.
export const saveNotificationUserSettings = createAsyncThunk(
  "user/save-notification-user-settings",
  async (body, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/user-settings", body, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Fire a test push to the caller's own devices so a rep can confirm push is
// actually working. Mirrors POST /notification/portal/test.
export const sendTestNotification = createAsyncThunk(
  "user/send-test-notification",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/test", {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Notification Control Hub (Phase 3C) — "mark all read": dismiss every still-open
// banner for the calling user in one tap. Server-side so it clears on every
// device; rows stay on the Notifications page as history (only their unread
// state clears). Mirrors POST /notification/portal/dismiss-all; returns
// { status, message, data: { cleared } }.
export const dismissAllNotifications = createAsyncThunk(
  "user/dismiss-all-notifications",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.post("/notification/portal/dismiss-all", {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

// Point Challenges — the no-lose "Challenge" bounty (4th Balance tab). An
// Issuer posts a task with a points Reward; a Recipient completes it (optionally
// uploading proof); the Issuer approves/rejects, or it auto-awards when no proof
// is required. Awards are COMPANY GRANTS (the BFF mints a single ledger row, no
// issuer deduction). Wire endpoints are mounted under /balance/portal in
// Portal-BFF routes/balanceRoute.js.
export const createPointChallenge = createAsyncThunk(
  "user/create-point-challenge",
  async ({ recipientRecId, title, reward, details, requiresProof, timerMinutes, startsAt, notify }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        "/balance/portal/point-challenges",
        { recipientRecId, title, reward, details, requiresProof, timerMinutes, startsAt, notify },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Group bounty — one challenge across a whole group. Standard mode (the default)
// writes one INDEPENDENT row per recipient and everyone can win. Early Bird mode
// (mode === "Early Bird") writes ONE shared row: the first person to claim it
// wins and it closes for everyone else. `mode` is omitted for Standard so existing
// callers are unchanged; the BFF reads a blank/absent mode as Standard.
export const createPointChallengeGroup = createAsyncThunk(
  "user/create-point-challenge-group",
  async ({ recipientRecIds, title, reward, details, requiresProof, timerMinutes, startsAt, notify, mode, blind, spinWheel, prizeTemplateId, prizeItemName, prizePointsCost, photoUrl, mediaUrls }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        "/balance/portal/point-challenges/group",
        { recipientRecIds, title, reward, details, requiresProof, timerMinutes, startsAt, notify, mode, blind, spinWheel, prizeTemplateId, prizeItemName, prizePointsCost, photoUrl, mediaUrls },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const listPointChallenges = createAsyncThunk(
  "user/list-point-challenges",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/point-challenges", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Whether the current user may ISSUE challenges (drives the "Challenge" tab's
// visibility). TABC-gated server-side; create endpoints re-check regardless.
export const getChallengeAccess = createAsyncThunk(
  "user/get-challenge-access",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/point-challenges/access", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Recipient marks the bounty done. Proof files (if any) go up as multipart in
// the "proof" field — same content-type the quality-inspection upload uses.
export const submitPointChallenge = createAsyncThunk(
  "user/submit-point-challenge",
  async ({ challengeId, files }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const form = new FormData();
      (files || []).forEach((f) => form.append("proof", f));
      const config = {
        headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${token}` },
      };
      const { data } = await instance.post(
        `/balance/portal/point-challenges/${challengeId}/submit`,
        form,
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Issuer approve/reject. decision is "approve" | "reject"; note is optional.
export const decidePointChallenge = createAsyncThunk(
  "user/decide-point-challenge",
  async ({ challengeId, decision, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        `/balance/portal/point-challenges/${challengeId}/decide`,
        { decision, note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const cancelPointChallenge = createAsyncThunk(
  "user/cancel-point-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(`/balance/portal/point-challenges/${challengeId}/cancel`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Recipient retracts their own Submitted claim, resetting the challenge to Open
// so they (or another eligible rep) can re-claim correctly.
export const retractPointChallenge = createAsyncThunk(
  "user/retract-point-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(`/balance/portal/point-challenges/${challengeId}/retract`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Spin The Wheel (Phase 3): the WINNER of a Spin-The-Wheel Early Bird spins for
// their points. The SERVER decides the outcome (weighted + season-capped) and
// returns { points, index } so the wheel animates to exactly the awarded wedge.
// One spin only — an already-spun row comes back 409 with data.points, which the
// wheel still surfaces (so a re-tap just re-shows the landed value).
export const spinPointChallenge = createAsyncThunk(
  "user/spin-point-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(`/balance/portal/point-challenges/${challengeId}/spin`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data) return rejectWithValue(error.response.data);
      return rejectWithValue(error.message);
    }
  }
);

// Issuer-only: list all entries (proof + timestamps) on a Blind Early Bird so the
// issuer can review proof DURING the race and decline bogus entries before the buzzer.
export const fetchBlindSubmissions = createAsyncThunk(
  "user/fetch-blind-submissions",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get(`/balance/portal/point-challenges/${challengeId}/submissions`, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Issuer-only: decline one Blind Early Bird entry during the timer. Silent —
// the entrant is NOT notified here; win/loss reveals only at the buzzer.
export const decideBlindSubmission = createAsyncThunk(
  "user/decide-blind-submission",
  async ({ challengeId, submissionId, note }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(
        `/balance/portal/point-challenges/${challengeId}/submissions/${submissionId}/decide`,
        { decision: "reject", note },
        config
      );
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Phase 4b: the company-wide "recent wins" ticker on the Balance page. Read-only
// and identical for every rep (the BFF serves it from a shared cache); the number
// is already redacted server-side for Blind Spin wins, so the payload is safe to
// render as-is.
// Item 6: office-wide public challenges — challenges the issuer marked "Visible
// to entire office". Returns only non-expired rows; MySQL-only read, no AT call.
export const fetchPublicChallenges = createAsyncThunk(
  "user/fetch-public-challenges",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/point-challenges/public", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const fetchRecentSpinWins = createAsyncThunk(
  "user/fetch-recent-spin-wins",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/point-challenges/recent-wins", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

// Phase 4c: the season jackpot tracker badge on the Balance page. Read-only and
// identical for every rep (the BFF serves it from a shared cache). Returns the
// capped Spin tiers (the $1,000 jackpot, the $100 prize) with how many have been
// won this season vs the season cap.
export const fetchSeasonJackpotStatus = createAsyncThunk(
  "user/fetch-season-jackpot-status",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/balance/portal/point-challenges/jackpot-status", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const nudgePointChallenge = createAsyncThunk(
  "user/nudge-point-challenge",
  async ({ challengeId }, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` } };
      const { data } = await instance.post(`/balance/portal/point-challenges/${challengeId}/nudge`, {}, config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const getTournamentBalanceCards = createAsyncThunk(
  "user/get-tournament-balance-cards",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/tournament/portal/me/balance-cards", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);

export const getTournamentHistory = createAsyncThunk(
  "user/get-tournament-history",
  async (_, { rejectWithValue, getState }) => {
    try {
      const token = getState().auth.token;
      const config = { headers: { Authorization: `Bearer ${token}` } };
      const { data } = await instance.get("/tournament/portal/me/history", config);
      return data;
    } catch (error) {
      if (error.response && error.response.data?.message) return rejectWithValue(error.response.data.message);
      return rejectWithValue(error.message);
    }
  }
);
